import React from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import { useNavigate } from "react-router-dom";
import Complete from "./Complete";

function UpdateVerification() {
  const navigation = useNavigate();

  return (
    <AppContainer title="Complete Installation">
      <div className="card custom-card main-content-body-profile">
        <div className="card-body tab-content h-100">
          <h4 className="card-title">Complete Installation</h4>

          <Complete navi={navigation} />
        </div>
      </div>
    </AppContainer>
  );
}

export default UpdateVerification;
